import { render, staticRenderFns } from "./ProjectCardOverview.vue?vue&type=template&id=8ad3c166&scoped=true"
import script from "./ProjectCardOverview.vue?vue&type=script&lang=js"
export * from "./ProjectCardOverview.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardOverview.vue?vue&type=style&index=0&id=8ad3c166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad3c166",
  null
  
)

export default component.exports